module.exports = __webpack_public_path__ + "static/img/xcaca.5eef614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/xcaca.png
// module id = 232
// module chunks = 1